export const DurationEnum = Object.freeze({
    HOURS_DURATION: 'HOURS_DURATION',
    LAST_DAY: 'LAST_DAY',
    LAST_WEEK: 'LAST_WEEK',
    LAST_MONTH: 'LAST_MONTH',
    RANGE: 'RANGE',
})
